module.exports = __webpack_public_path__ + "static/media/ic_update_billing_tag.b23b0903.svg";